import { LooseObject } from 'Angular/interfaces/loose-object.interface';

const isObject = (value: LooseObject): boolean => {
    return value && typeof value === 'object' && value.constructor === Object;
};

/* eslint no-restricted-syntax: "off", no-param-reassign: "off" */
export const convertNestedBooleanToString = (state: LooseObject): void => {
    if (Array.isArray(state)) {
        for (let i = 0; i < state.length; i += 1) {
            convertNestedBooleanToString(state[i]);
        }
    } else if (isObject(state)) {
        for (const key in state) {
            if (state[key] === true) {
                state[key] = 'true';
            } else if (state[key] === false) {
                state[key] = 'false';
            } else if (isObject(state[key]) || Array.isArray(state[key])) {
                convertNestedBooleanToString(state[key]);
            }
        }
    }
};

/**
 * Convert strings 'true' and 'false' into booleans true and false.
 *
 * Note: To keep things consistent, all JSON objects serialized and returned from the backend have their boolean
 * values stored as strings. But we convert these strings into booleans for comparison on the front end.
 * @param state - The JSON data returned from the backend.
 */
export const convertNestedStringToBoolean = (state: LooseObject): void => {
    if (Array.isArray(state)) {
        for (let i = 0; i < state.length; i += 1) {
            convertNestedStringToBoolean(state[i]);
        }
    } else if (isObject(state)) {
        for (const key in state) {
            if (state[key] === 'true') {
                state[key] = true;
            } else if (state[key] === 'false') {
                state[key] = false;
            } else if (isObject(state[key]) || Array.isArray(state[key])) {
                convertNestedStringToBoolean(state[key]);
            }
        }
    }
};
